import { forwardRef, useImperativeHandle, useState } from "react";
import { RiCloseLine } from "@remixicon/react";
import { Input } from "reactstrap";

export interface ImageSelectorHandles {
  triggerAction: VoidFunction;
  resetComponent: VoidFunction;
}

// eslint-disable-next-line react/display-name
const ImageSelector = forwardRef<
  ImageSelectorHandles,
  { setCurrentImage: React.Dispatch<React.SetStateAction<File | undefined>> }
>(({ setCurrentImage }, ref) => {
  const [displayImage, setDisplayImage] = useState<string | undefined>(undefined);

  useImperativeHandle(ref, () => ({
    triggerAction() {
      const el = document.getElementById("fileUpload");
      el?.click();
    },
    resetComponent() {
      setDisplayImage(undefined);
    },
  }));

  return (
    <>
      {displayImage && (
        <div className="d-inline-block position-relative m-3 bg-light border rounded">
          <div
            className="position-absolute top-0 start-100 translate-middle avatar-xxs border rounded-circle"
            onClick={() => {
              setCurrentImage(undefined);
              setDisplayImage(undefined);
            }}
          >
            <RiCloseLine />
          </div>
          <img src={displayImage} alt="" className="avatar-sm" />
        </div>
      )}

      <Input
        id="fileUpload"
        name="fileUpload"
        type="file"
        accept="image/*"
        onInput={(ev) => {
          const target = ev.target as HTMLInputElement;

          if (target.files && target.files.length > 0) {
            setCurrentImage(target.files[0]);
            setDisplayImage(URL.createObjectURL(target.files[0]));
          }
        }}
        // https://stackoverflow.com/questions/42192346/how-to-reset-reactjs-file-input
        key={displayImage}
        style={{ display: "none" }}
      />
    </>
  );
});

export { ImageSelector };
